import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"margin":"auto","display":"block","width":"200px"},
      src: "/static/img/ss-logo-horizontal-v2.png"
    })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"text-align":"center"},
    class: "ant-col ant-col-xs-24 ant-col-xl-24"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "NeoX 2025 - Todos os direitos reservados")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"text-align":"center"},
    class: "ant-col ant-col-xs-24 ant-col-xl-24"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Um produto "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#0B70E1","font-weight":"bolder"} }, "Sabre Sistemas")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"text-align":"center"},
    class: "ant-col ant-col-xs-24 ant-col-xl-24"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      style: {"margin-top":"10px"},
      href: "https://sabresistemas.com.br/fale-com-consultor/"
    }, "Fale conosco")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_sobre_versao_sistema = _resolveComponent("sobre-versao-sistema")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    footer: null,
    width: "1000px",
    "wrap-class-name": "scroll-modal"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Sobre o NeoX")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_sobre_versao_sistema, {
                versao: _ctx.state.versaoSistema
              }, null, 8, ["versao"]),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    class: "ss-accordion",
                    header: "VERSÕES ANTERIORES"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.versaoSistema.versoesAnteriores, (versao, index) => {
                        return (_openBlock(), _createBlock(_component_sobre_versao_sistema, {
                          key: index,
                          versao: versao
                        }, null, 8, ["versao"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible"]))
}